import { Layout } from "$components";
import useProjectDetailsLogic from "./hooks/useProjectDetailsLogic";
import ProjectHeader from "./sections/ProjectHeader";
import ProjectGeneralInfo from "./sections/ProjectGeneralInfo";
import ProjectContactInfo from "./sections/ProjectContactInfo";
import ProjectDockyards from "./sections/ProjectDockyards";
import ProjectAttachments from "./sections/ProjectAttachments";
import ProjectModals from "./sections/ProjectModals";
import { useStyles } from "./styles";

function ProjectDetails() {
  const clasx = useStyles();
  const logic = useProjectDetailsLogic();

  if (!logic.idProject) {
    return null;
  }

  return (
    <Layout
      className={clasx.ProjectDetailLayout}
      renderHead={() => (
        <ProjectHeader
          project={logic.project}
          isProjectDisabled={logic.isProjectDisabled}
          canEdit={logic.canEdit}
          handleSwitchToggle={logic.handleSwitchToggle}
          dockyards={logic.dockyards}
          setModalDeleteOpen={logic.setModalDeleteOpen}
          isLoading={logic.isLoading}
        />
      )}
      title={logic.project?.name}
    >
      <div style={{ display: "flex", marginBottom: 18 }}>
        <ProjectGeneralInfo
          project={logic.project}
          canEdit={logic.canEdit}
          isProjectDisabled={logic.isProjectDisabled}
          handleEditProject={logic.handleEditProject}
        />
        <ProjectContactInfo
          project={logic.project}
          canEdit={logic.canEdit}
          isProjectDisabled={logic.isProjectDisabled}
          handleEditProject={logic.handleEditProject}
          isAlias={logic.isAlias}
          cleanEmail={logic.cleanEmail}
          email={logic.email}
          fullname={logic.fullname}
        />
      </div>
      <ProjectDockyards
        active={logic.active}
        canEdit={logic.canEdit}
        isProjectDisabled={logic.isProjectDisabled}
        project={logic.project}
        handleSwitch={logic.handleSwitch}
        openPopinDockyard={logic.openPopinDockyard}
        setShowImportModal={logic.setShowImportModal}
        setShowImportEditModal={logic.setShowImportEditModal}
        dockyardTableData={logic.dockyardTableData}
        handleSwitchDock={logic.handleSwitchDock}
      />
      <ProjectAttachments
        project={logic.project}
        isProjectDisabled={logic.isProjectDisabled}
        canEdit={logic.canEdit}
        isAdminUser={logic.isAdminUser}
        control={logic.control}
      />
      <ProjectModals
        idProject={logic.idProject}
        project={logic.project}
        showImportModal={logic.showImportModal}
        setShowImportModal={logic.setShowImportModal}
        showImportEditModal={logic.showImportEditModal}
        setShowImportEditModal={logic.setShowImportEditModal}
        onImportFinish={logic.onImportFinish}
        openSnackbar={logic.openSnackbar}
        filters={logic.filters}
        modalActive={logic.modalActive}
        setModalActive={logic.setModalActive}
        isProjectDisabled={logic.isProjectDisabled}
        enableProject={logic.enableProject}
        disableProject={logic.disableProject}
        errorUpload={logic.errorUpload}
        setErrorUpload={logic.setErrorUpload}
        errorMessage={logic.errorMessage}
        handleCloseError={logic.handleCloseError}
        isOpened={logic.isOpened}
        togglePopin={logic.togglePopin}
        formProject={logic.formProject}
        handleSubmit={logic.handleSubmit}
        error={logic.error}
        submitting={logic.submitting}
        isDockyardPopinOpened={logic.isDockyardPopinOpened}
        toggleDock={logic.toggleDock}
        formDockyard={logic.formDockyard}
        handleSubmitDock={logic.handleSubmitDock}
        errorDockyard={logic.errorDockyard}
        submittingDockyard={logic.submittingDockyard}
        modalDeleteOpen={logic.modalDeleteOpen}
        setModalDeleteOpen={logic.setModalDeleteOpen}
        deleteProject={logic.deleteProject}
      />
    </Layout>
  );
}

export default ProjectDetails;
